"use client";

import NextImage from "next/image";
import { Text } from "../../../ui/text";
import {
  useInstitutionalProductCard,
  useInstitutionalProductCardProps,
} from "./use-institutional-product-card";
import Link from "next/link";

export type InstitutionalProductCardProps = useInstitutionalProductCardProps;

const InstitutionalProductCard = (props: InstitutionalProductCardProps) => {
  const {
    className,
    styles,
    data: { title, description, logo, background, url },
  } = useInstitutionalProductCard(props);

  return (
    <Link href={url || ""} title={title}>
      <article
        data-component-name="institutional-product-card"
        className={styles.base({ className })}
      >
        {!!background && (
          <NextImage
            alt={background.alternativeText || ""}
            fill
            src={background.url}
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            quality={100}
            className={styles.img()}
          />
        )}
        <div className={styles.contentWrapper()}>
          <header className={styles.header()}>
            {!!title && (
              <Text
                tag="h3"
                size="h5"
                weight="medium"
                className={styles.title()}
              >
                {title}
              </Text>
            )}
          </header>
          <footer className={styles.footer()}>
            <Text className={styles.description()} size="body" weight="medium">
              {description}
            </Text>
            {!!logo && (
              <div className={styles.logoWrapper()}>
                <NextImage
                  alt={logo.alternativeText || ""}
                  src={logo.url}
                  width={logo.width}
                  height={logo.height}
                  quality={100}
                  className={styles.logo()}
                />
              </div>
            )}
          </footer>
        </div>
      </article>
    </Link>
  );
};

export default InstitutionalProductCard;
